import { SessionState } from 'store/reducers/session/types';
import { ReadReservationsState } from 'store/reducers/room/readReservationsData/types';
import { LodgingFormDataState } from 'store/reducers/lodgingOption/getFormData/types';
import { AddLodgingOptionState } from 'store/reducers/lodgingOption/add/types';
import { ViewLodgingOptionState } from 'store/reducers/lodgingOption/view/types';
import { GetLodgingRequestsState } from 'store/reducers/lodgingRequest/get/types';
import { ViewLodgingRequestState } from 'store/reducers/lodgingRequest/view/types';
import { PreferredRoommatesState } from 'store/reducers/lodgingRequest/preferredRoommates/types';
import { AddEditRoomState } from 'store/reducers/room/add-edit-room/types';
import { DeleteRoomState } from 'store/reducers/room/deleteRoom/types';
import { RoomFormDataState } from 'store/reducers/room/formData/types';
import { EditLodgingOptionState } from 'store/reducers/lodgingOption/edit/types';
import { CancelLodgingRequestState } from 'store/reducers/lodgingRequest/cancel/types';
import { ReopenLodgingRequestState } from 'store/reducers/lodgingRequest/reopen/types';
import { EditLodgingRequestState } from 'store/reducers/lodgingRequest/edit/types';
import { GetLodgingsState } from 'store/reducers/lodgingOption/get/types';
import { DeleteLodgingOptionState } from 'store/reducers/lodgingOption/delete/types';
import { SearchReservationState } from 'store/reducers/lodgingOption/searchReservation/types';
import { LocationMatchesState } from 'store/reducers/lodgingOption/locationMatches/types';
import { LocationMatchesRoomsState } from 'store/reducers/room/locationMatchesRooms/types';
import { FiltersState } from 'store/reducers/filter/filters/types';
import { ModalState } from 'store/reducers/newVersionModal/modal/types';
import { GetGuestsForFilterState } from 'store/reducers/lodgingRequest/getGuestsForFilter/types';
import { ReservationsFiltersState } from 'store/reducers/room/readReservationsFilters/types';
import { LodgingOptionMassAddState } from 'store/reducers/lodgingOption/massAdd/types';
import { LocationRoomsState } from 'store/reducers/room/locationRooms/types';
import { ConfirmBookingsState } from 'store/reducers/booking/confirmBookings/types';
import { SaveGuestToDraftState } from 'store/reducers/booking/saveGuestToDraft/types';
import { RemoveGuestFromRoomState } from 'store/reducers/booking/removeGuestFromRoom/types';
import { GetLodgingRequestsCountState } from 'store/reducers/lodgingRequest/get-count/types';
import { RoomMassAddState } from 'store/reducers/room/massAdd/types';
import { LocationDataState } from 'store/reducers/lodgingRequest/getLocationData/types';
import { GetFormDataState } from 'store/reducers/lodgingRequest/getFormData/types';
import { AddByManagerState } from 'store/reducers/lodgingRequest/addByManager/types';
import { RoomExportExcelState } from 'store/reducers/room/exportExcel/types';
import { LodgingOptionExportExcelState } from 'store/reducers/lodgingOption/exportExcel/types';
import { LodgingRequestExportExcelState } from 'store/reducers/lodgingRequest/exportExcel/types';
import { AllPreferredRoommatesState } from './reducers/lodgingRequest/allPreferredRoommates/types';
import { HotelInfoState } from 'store/reducers/hotelInfo/types';
import { CheckIfExistsState } from 'store/reducers/lodgingRequest/checkIfExists/types';
import { RequestsFiltersState } from 'store/reducers/lodgingRequest/readRequestsFilters/types';
import { ReservationTableFiltersState } from 'store/reducers/room/reservationTableFilters/types';
import { RequestTableFiltersState } from 'store/reducers/lodgingRequest/requestTableFilters/types';
import { CloneLodgingRequestState } from 'store/reducers/lodgingRequest/clone/types';
import { EditLodgingRequestDatesState } from 'store/reducers/lodgingRequest/edit-dates/types';
import { ReactivateRoomState } from 'store/reducers/room/reactivate/types';
import { GetActivityLogsState } from 'store/reducers/activity-log/get-activity-logs/types';
import { RoomDetailsState } from 'store/reducers/room/get-details/types';
import { GetReadyForAssignmentDataState } from 'store/reducers/lodgingRequest/get-ready-for-assignment-data/types';
import { GetLodgingRequestsAllCountState } from 'store/reducers/lodgingRequest/get-all-count/types';
import { RequestTableColumnsState } from 'store/reducers/lodgingRequest/request-table-columns/types';
import { RequestsByClientFiltersState } from 'store/reducers/lodgingRequest/get-requests-by-client-filters/types';
import { RequestsByClientState } from 'store/reducers/lodgingRequest/get-requests-by-client/types';
import { RequestsByClientTableFiltersState } from 'store/reducers/lodgingRequest/requests-by-client-table-filters/types';
import { GetClientsForFilterState } from 'store/reducers/lodgingRequest/get-clients-for-filter/types';
import { GetLocationsForFilterState } from 'store/reducers/lodgingRequest/get-locations-for-filter/types';
import { MassActionsState } from 'store/reducers/lodgingRequest/get-mass-actions/types';
import { LocationMatchesForMassBookingState } from './reducers/lodgingOption/location-matches-for-mass-booking/types';
import { SelectedForMassBookingState } from './reducers/lodgingRequest/selected-for-mass-booking/types';
import { LocationMatchesRoomsForMassBookingState } from './reducers/room/location-matches-rooms-for-mass-booking/types';
import { GetSplitFormDataState } from 'store/reducers/lodgingRequest/get-split-form-data/types';
import { GetBookingsByReservationsState } from "./reducers/lodgingRequest/get-bookings-by-reservations/types";
import { ReadOccupancyRateState } from 'store/reducers/room/readOccupancyRateData/types';
import { OccupancyRateFiltersState } from 'store/reducers/room/readOccupancyRateFilters/types';
import { OccupancyRateTableFiltersState } from "./reducers/room/occupancyRateTableFilters/types";
import { GetLocationMatchesByRequestState } from './reducers/lodgingOption/get-location-matches-by-request/types';
import { GetReservationsCountState } from "./reducers/room/get-count/types";
import { GetLodgingsCountState } from "./reducers/lodgingOption/get-count/types";
import { GetActiveReservationsCountState } from './reducers/room/get-active-reservations-count/types';
import { GetAllBookingsState } from "./reducers/lodgingRequest/get-all-bookings/types";
import { GetUsersState } from 'store/reducers/user/get-users/types';
import { GetUserState } from 'store/reducers/user/get-user/types';
import { GetRolesState } from 'store/reducers/user/get-roles/types';
import { PostUserState } from 'store/reducers/user/post-user/types';
import { GetStatusState } from 'store/reducers/user/get-statuses/types';
import { GetUsersTableFiltersState } from 'store/reducers/user/get-users-table-filters/types';
import { LodgingsAndReservationsFilterState } from 'store/reducers/filter/lodgingsAndReservationsFilter/types';
import { GetAddressesForFilterState } from './reducers/lodgingOption/get-addresses-for-filter/types';
import { GetTypesForFilterState } from './reducers/lodgingOption/get-types-for-filter/types';
import { LodgingTableFiltersState } from './reducers/lodgingOption/lodging-table-filters/types';
import { GetLodgingPoliciesState } from './reducers/lodgingPolicy/get-lodging-policies/types';
import { GetLodgingPolicyState } from './reducers/lodgingPolicy/get-lodging-policy/types';
import { PostLodgingPolicyState } from './reducers/lodgingPolicy/post-lodging-policy/types';
import { MergeLodgingOptionState } from './reducers/lodgingOption/merge-lodging-options/types';
import { GetExternalCallsFiltersState } from './reducers/external-api-call-log/get-external-calls-filters/types';
import { GetExternalCallsState } from './reducers/external-api-call-log/get-external-calls/types';
import { GetExternalCallsTableFiltersState } from './reducers/external-api-call-log/get-external-calls-table-filters/types';
import { LodgingRequestReportExcelState } from './reducers/lodgingRequest/getReportExcel/types';
import { RoomReportExcelState } from './reducers/room/getReportExcel/types';
import { LodgingOptionReportExcelState } from './reducers/lodgingOption/getReportExcel/types';
import { GetAutomatedReportsState } from 'store/reducers/automated-report/get-automated-reports/types';
import { GetAutomatedReportState } from 'store/reducers/automated-report/get-automated-report/types';
import { PostAutomatedReportState } from 'store/reducers/automated-report/post-automated-report/types';
import { DeleteAutomatedReportState } from 'store/reducers/automated-report/delete-automated-report/types';
import { GetCorporateClientsState } from 'store/reducers/corporate-client/get-corporate-clients/types';
import { GetCorporateClientState } from 'store/reducers/corporate-client/get-corporate-client/types';
import { PostCorporateClientState } from 'store/reducers/corporate-client/post-corporate-client/types';
import { DeleteCorporateClientState } from 'store/reducers/corporate-client/delete-corporate-client/types';
import { UsersActivityFiltersState } from './reducers/users-activity/get-users-activity-filters/types';
import { GetUsersActivityState } from 'store/reducers/users-activity/get-users-activity/types';
import { GetUsersActivityTableFiltersState } from './reducers/users-activity/get-users-activity-table-filters/types';
import { ReadReservationsOccupancyInsightsState } from 'store/reducers/occupancy-insights/readReservationsOccupancyInsightsData/types';
import { OccupancyInsightsFiltersState } from 'store/reducers/occupancy-insights/readOccupancyInsightsFilters/types';
import { OccupancyInsightsTableFiltersState } from "./reducers/occupancy-insights/occupancyInsightsTableFilters/types";
import { ReadReservationOccupancyInsightsState } from 'store/reducers/occupancy-insights/readReservationOccupancyInsightsData/types';
import { GetReservationProvidersState } from 'store/reducers/reservation-provider/get-reservation-providers/types';
import { GetReservationProviderState } from 'store/reducers/reservation-provider/get-reservation-provider/types';
import { GetReservationProviderSettingsState } from 'store/reducers/reservation-provider/get-reservation-provider-settings/types';
import { PostReservationProviderState } from 'store/reducers/reservation-provider/post-reservation-provider/types';
import { GetReservationProviderSelectListState } from 'store/reducers/reservation-provider/get-reservation-provider-select-list/types';
import { GetProviderLodgingPolicyState } from 'store/reducers/reservation-provider/get-provider-lodging-policy/types';
import { SetDefaultReservationProviderState } from 'store/reducers/reservation-provider/set-default-reservation-provider/types';
import { GetExportJobsState } from 'store/reducers/export-jobs/get-export-jobs/types';
import { ExportJobsFiltersState } from 'store/reducers/export-jobs/get-export-jobs-filters/types';
import { ExportJobsTableFiltersState } from 'store/reducers/export-jobs/export-jobs-table-filters/types';
import { GetGuestsState } from 'store/reducers/guest/get-guests/types';
import { GuestTableFiltersState } from 'store/reducers/guest/guest-table-filters/types';
import { ViewGuestState } from 'store/reducers/guest/view/types';
import { EditGuestState } from 'store/reducers/guest/edit/types';

export interface LodgingOptionState {
  get: GetLodgingsState;
  formData: LodgingFormDataState;
  add: AddLodgingOptionState;
  view: ViewLodgingOptionState;
  edit: EditLodgingOptionState;
  delete: DeleteLodgingOptionState;
  searchReservation: SearchReservationState;
  locationMatches: LocationMatchesState;
  massAdd: LodgingOptionMassAddState;
  exportExcel: LodgingOptionExportExcelState;
  getActivityLogs: GetActivityLogsState;
  locationMatchesForMassBooking: LocationMatchesForMassBookingState;
  getLocationMatchesByRequest: GetLocationMatchesByRequestState;
  getAddressesForFilter: GetAddressesForFilterState;
  getTypesForFilter: GetTypesForFilterState;
  lodgingTableFilters: LodgingTableFiltersState;
  mergeLodgingOption: MergeLodgingOptionState;
  getReportExcel: LodgingOptionReportExcelState;
  getCount: GetLodgingsCountState;
}

export interface LodgingPolicyState {
  getLodgingPolicies: GetLodgingPoliciesState;
  getLodgingPolicy: GetLodgingPolicyState;
  postLodgingPolicy: PostLodgingPolicyState;
}

export interface LodgingRequestState {
  get: GetLodgingRequestsState;
  view: ViewLodgingRequestState;
  cancel: CancelLodgingRequestState;
  reopen: ReopenLodgingRequestState;
  edit: EditLodgingRequestState;
  preferredRoommates: PreferredRoommatesState;
  allPreferredRoommates: AllPreferredRoommatesState;
  guestsForFilter: GetGuestsForFilterState;
  getCount: GetLodgingRequestsCountState;
  getLocationData: LocationDataState;
  getFormData: GetFormDataState;
  addByManager: AddByManagerState;
  exportExcel: LodgingRequestExportExcelState;
  checkIfExists: CheckIfExistsState;
  readRequestsFilters: RequestsFiltersState;
  requestTableFilters: RequestTableFiltersState;
  cloneLodgingRequest: CloneLodgingRequestState;
  editLodgingRequestDates: EditLodgingRequestDatesState;
  getActivityLogs: GetActivityLogsState;
  getReadyForAssignmentData: GetReadyForAssignmentDataState;
  getAllCount: GetLodgingRequestsAllCountState;
  tableColumns: RequestTableColumnsState;
  requestsByClientFilters: RequestsByClientFiltersState;
  requestsByClient: RequestsByClientState;
  requestsByClientTableFilters: RequestsByClientTableFiltersState;
  clientsForFilter: GetClientsForFilterState;
  locationsForFilter: GetLocationsForFilterState;
  massActions: MassActionsState;
  selectedForMassBookingData: SelectedForMassBookingState;
  getSplitFormData: GetSplitFormDataState;
  getBookingsByReservationId: GetBookingsByReservationsState;
  getAllBookings: GetAllBookingsState;
  getReportExcel: LodgingRequestReportExcelState;
}

export interface OccupancyInsightsState {
  readOccupancyInsightsFilters: OccupancyInsightsFiltersState;
  occupancyInsightsTableFilters: OccupancyInsightsTableFiltersState;
  readReservationsOccupancyInsightsData: ReadReservationsOccupancyInsightsState;
  readReservationOccupancyInsightsData: ReadReservationOccupancyInsightsState;
}

export interface RoomState {
  addEdit: AddEditRoomState;
  delete: DeleteRoomState;
  formData: RoomFormDataState;
  locationMatchesRooms: LocationMatchesRoomsState;
  locationRooms: LocationRoomsState;
  readReservationData: ReadReservationsState;
  readReservationsFilters: ReservationsFiltersState;
  exportExcel: RoomExportExcelState;
  massAdd: RoomMassAddState;
  reservationTableFilters: ReservationTableFiltersState;
  reactivate: ReactivateRoomState;
  getActivityLogs: GetActivityLogsState;
  roomDetails: RoomDetailsState;
  locationMatchesRoomsForMassBooking: LocationMatchesRoomsForMassBookingState;
  readOccupancyRateData: ReadOccupancyRateState;
  readOccupancyRateFilters: OccupancyRateFiltersState;
  occupancyRateTableFilters: OccupancyRateTableFiltersState;
  getCount: GetReservationsCountState;
  getActiveReservationsCount: GetActiveReservationsCountState;
  getReportExcel: RoomReportExcelState;
}

export interface BookingState {
  confirmBookings: ConfirmBookingsState;
  saveGuestToDraft: SaveGuestToDraftState;
  removeGuestFromRoom: RemoveGuestFromRoomState;
}

export interface UserState {
  getUsers: GetUsersState;
  getRoles: GetRolesState;
  getUser: GetUserState;
  postUser: PostUserState;
  getStatuses: GetStatusState;
  getUserActivityLogs: GetActivityLogsState;
  getUsersTableFilters: GetUsersTableFiltersState;
}

export interface UsersActivityState {
  usersActivityFilters: UsersActivityFiltersState;
  getUsersActivity: GetUsersActivityState;
  usersActivityTableFilters: GetUsersActivityTableFiltersState;
}

export interface FilterState {
  filters: FiltersState;
  lodgingsAndReservationsFilter: LodgingsAndReservationsFilterState;
}

export interface NewVersionModalState {
  modal: ModalState;
}

export interface ExternalApiCallLogState {
  externalCallsFilters: GetExternalCallsFiltersState;
  getExternalCalls: GetExternalCallsState;
  externalCallsTableFilters: GetExternalCallsTableFiltersState;
}

export interface AutomatedReportState {
  getAutomatedReports: GetAutomatedReportsState;
  getAutomatedReport: GetAutomatedReportState;
  postAutomatedReport: PostAutomatedReportState;
  deleteAutomatedReport: DeleteAutomatedReportState;
}

export interface CorporateClientState {
  getCorporateClients: GetCorporateClientsState;
  getCorporateClient: GetCorporateClientState;
  postCorporateClient: PostCorporateClientState;
  deleteCorporateClient: DeleteCorporateClientState;
}

export interface ReservationProviderState {
  getReservationProviders: GetReservationProvidersState;
  getReservationProvider: GetReservationProviderState;
  getReservationProviderSettings: GetReservationProviderSettingsState;
  postReservationProvider: PostReservationProviderState;
  getReservationProviderSelectList: GetReservationProviderSelectListState;
  getProviderLodgingPolicy: GetProviderLodgingPolicyState;
  setDefaultReservationProvider: SetDefaultReservationProviderState;
}

export interface ExportJobsState {
  exportJobsFilters: ExportJobsFiltersState;
  getExportJobs: GetExportJobsState;
  exportJobsTableFilters: ExportJobsTableFiltersState;
}

export interface GuestState {
  getGuests: GetGuestsState;
  guestTableFilters: GuestTableFiltersState;
  view: ViewGuestState;
  getActivityLogs: GetActivityLogsState;
  edit: EditGuestState;
}

export interface RootState {
  session: SessionState;
  lodgingRequest: LodgingRequestState;
  lodgingPolicy: LodgingPolicyState;
  lodgingOption: LodgingOptionState;
  room: RoomState;
  booking: BookingState;
  filter: FilterState;
  hotelInfo: HotelInfoState;
  user: UserState;
  usersActivity: UsersActivityState;
  modal: NewVersionModalState;
  externalApiCallLog: ExternalApiCallLogState;
  automatedReport: AutomatedReportState;
  corporateClient: CorporateClientState;
  occupancyInsights: OccupancyInsightsState;
  reservationProvider: ReservationProviderState;
  exportJobs: ExportJobsState;
  guest: GuestState;
}

export interface DefaultState {
  isLoading: boolean;
  errorMessage: string;
}

export interface Filters {
  [key: string]: string | number | number[] | string[] | null | undefined;
}

export type DropdownItem = {
  value: string;
  text: string;
};

export const defaultState = {
  isLoading: false,
  errorMessage: "",
};

export type TableFilter = {
  type?: string;
  items?: DropdownItem[];
  clearable?: boolean;
  menuIsOpen?: boolean;
  hasDropdownIndicator?: boolean;
};

export interface TableValidationError {
  columnName: string;
  errorMessage: string;
}

export interface MassAddRow {
  errors: TableValidationError[];
}

export interface MergeLodgingOptionsRow {
  errors: TableValidationError[];
}

export interface MassAddResponse<T> {
  rows?: T[];
  addedRowsCount?: number;
}

export interface BaseTableRequest {
  paging: {
    page: number,
    pageSize: number
  },
  sorting: {
    id: string;
    order: string;
  }
}

export interface BaseTableResponse<T> {
  totalCount: number;
  rows: T[];
}

export type RoomStatuses = 'Active' | 'Canceled';
